export default __webpack_public_path__ + "static/media/MetroMVMNT_Logo.ac14e577.png";